<template>
    <div>
      <div class="box">
          <div class="body">
              <div class="header">
                  <img class="h-img" src="static/images/logo2.png" alt="">
              </div>
              <div>
                  <div class="item" :class="{'item-d':isReg}">
                    <Icon class="icon-size" type="md-person" />
                    <Input class="i-inp" v-model="mail" placeholder="请输入邮箱"></Input>
                  </div>
                  <div class="item" :class="{'item-d':isReg}">
                    <Icon class="icon-size"  type="md-lock" />
                    <Input class="i-inp" v-model="passwd" type="password" placeholder="请输入密码"></Input>
                  </div>
                  <div class="item" :class="{'item-d':isReg}" v-if="isReg">
                    <Icon class="icon-size"  type="md-lock" />
                    <Input class="i-inp" v-model="passwd_conf" type="password" placeholder="确认密码"></Input>
                  </div>
                  <div class="item-d">
                      <Button @click="clogin" class="btn" v-if="!isReg">登录</Button>
                      <Button @click="cregister" class="btn" v-else-if="true">注册</Button>
                      <Button @click="cregister" class="btn" v-else>继续注册</Button>
                  </div>
                  <div class="item">
                      <a style="font-size: 20px;" @click="changeState" href="javascript:void(0)" v-if="!isReg">立即注册</a>
                      <a v-else-if="true" @click="changeState"  href="javascript:void(0)">已有账号，直接登录</a>
                      <p v-else style="color:red;">亲，验证邮件已经发送到邮箱，请到邮箱内点击验证链接后，点击继续注册完成注册</p>
                      <p style="color:red;">新注册用户送10个请求次数,可立即体验</p>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
import helper from '../lib/helper'

export default {
  data () {
    return {
      isLogin: false,
      mail: '',
      passwd: '',
      passwd_conf: '',
      isReg: false,
      regone: false
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    changeState () {
      this.mail = ''
      this.passwd = ''
      this.passwd_conf = ''
      this.isReg = !this.isReg
    },
    getUserInfo () {
      // 获取用户信息
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/userinfo'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          console.log('登录成功', res.data)
          var uinfo = res.data.data
          console.log('userinfo', uinfo)
          helper.putUser(uinfo)
          that.$router.push({
            path: '/'
          })
        } else if (res.data.code === 401) {
          helper.removeLogin()
          helper.removeUser()
        } else if (res.data.code === 403) {
          // that.$Message.info('没有权限')
        } else {
          console.log('conform error', res)
          // that.$Message.info(res.data.msg)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
        // that.$Message.info('获取数据失败')
      })
    },
    clogin () {
      if (this.mail.length === 0) {
        this.$Message.info('邮箱不能为空')
        return
      }
      if (!this.isEmail(this.mail)) {
        this.$Message.info('请输入正确的邮箱')
        return
      }
      if (this.passwd.length === 0) {
        this.$Message.info('密码不能为空')
        return
      }
      var url = this.$store.state.baseurl + '/mapi/entry/login'
      console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
          params: {
            email: this.mail,
            password: this.passwd
          }
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          console.log('登录成功', res.data)
          var uinfo = res.data.data
          console.log('userinfo', uinfo)
          helper.putUser(uinfo)
          that.$router.push({
            path: `/`
          })
        } else if (res.data.code === 401) {
          helper.removeLogin()
          helper.removeUser()
          that.$router.push({
            path: `/login`
          })
        } else if (res.data.code === 403) {
          that.$Message.info('没有权限')
        } else {
          that.$Message.info(res.data.msg)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
        that.$Message.info('获取数据失败')
      })
    },
    cverifyemail () {
      if (this.mail.length === 0) {
        this.$Message.info('邮箱不能为空')
        return
      }
      var url = this.$store.state.baseurl + '/mapi/entry/getcode'
      console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
          params: {
            email: this.mail
          }
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          that.regone = false
        //   console.log('邮件发送完成', res.data)
        } else {
          that.$Message.info(res.data.msg)
        }
      }).catch((e) => {
        console.log('邮箱验证失败', e)
        that.$Message.info('邮箱验证失败')
      })
    },
    isEmail (mail) {
      var reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (mail === '') {
        return false
      }
      return reg.test(mail)
    },
    cregister () {
      console.log('cregister')
      if (this.regone) {
        if (this.mail.length === 0) {
          this.$Message.info('邮箱不能为空')
          return
        }
        if (this.passwd.length === 0) {
          this.$Message.info('密码不能为空')
          return
        }
        if (this.passwd_conf.length === 0) {
          this.$Message.info('确认密码不能为空')
          return
        }
        if (this.passwd_conf !== this.passwd) {
          this.$Message.info('二次密码输入不一致')
          return
        }
        this.cverifyemail()
        // 测试后注释掉
        // this.regone = false
      } else {
        if (this.mail.length === 0) {
          this.$Message.info('邮箱不能为空')
          return
        }
        if (!this.isEmail(this.mail)) {
          this.$Message.info('请输入正确的邮箱')
          return
        }
        if (this.passwd.length === 0) {
          this.$Message.info('密码不能为空')
          return
        }
        if (this.passwd_conf.length === 0) {
          this.$Message.info('确认密码不能为空')
          return
        }
        if (this.passwd_conf !== this.passwd) {
          this.$Message.info('二次密码输入不一致')
          return
        }
        var url = this.$store.state.baseurl + '/mapi/entry/reg'
        console.log('url', url)
        var that = this
        this.axios.post(
          url,
          {
            email: this.mail,
            password: this.passwd
          }
        ).then(function (res) {
          if (res.data.code === 200) {
            console.log('登录成功', res.data)
            var uinfo = res.data.data.userinfo
            console.log('userinfo', uinfo)
            helper.putUser(uinfo)
            that.$router.push({
              path: `/`
            })
          } else if (res.data.code === 401) {
            helper.removeLogin()
            helper.removeUser()
          } else if (res.data.code === 403) {
            that.$Message.info('没有权限')
          } else {
            that.$Message.info(
              {
                content: res.data.msg,
                duration: 5
              })
          }
        }).catch((e) => {
          console.log('获取数据失败', e)
          that.$Message.info('获取数据失败')
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.box {
    display: flex;
    justify-content: center;
    flex-direction: row;
}
.body {
    width: 390px;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 120px;
    border: 1px solid #eeeeee;
}
.header {
    width: 100%;
    height: 130px;
    background: #398dee;
    .h-img {
        position: relative;
        top: 37px;
        right: 11px;
    }
}
.item {
    // background: #87bdfb;
    margin: 40px 20px;
    padding: 5px;
    border-radius: 5px;
    .icon-size {
        font-size: 26px;
        position: relative;
        top: 4px;
    }
    .i-inp {
        width: 81%;
    }
    a:link{color: #2d8cf0;}
    a:hover{color: #2d8cf0;}
    a:visited{color: #2d8cf0;}
}
.item-d {
    margin: 19px 20px;
}
.btn {
    background: cornflowerblue;
    border-radius: 10px;
    height: 35px;
    color: #fff;
    line-height: 35px;
    width: 92%;
    margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue